import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	apps: {
		id: 'spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps',
		defaultMessage: 'Apps',
		description: 'Apps link item',
	},
	appFields: {
		id: 'spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields',
		defaultMessage: 'App fields',
		description: 'App fields link item within apps sub-menu',
	},
	backItem: {
		id: 'spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item',
		defaultMessage: 'Back',
		description: 'Back menu item',
	},
});
